import { useEffect } from 'react';
import genericHelpers from '../../_utils/generic-helpers';

const handleViewportResize = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Sets the CSS custom property --vh to address the mobile browser 100vh issue,
// where 100vh often includes dynamic browser UI elements like address bars,
// leading to incorrect viewport height calculations.
const useViewportResize = () => {
  useEffect(() => {
    const debouncedHandleResize = genericHelpers.debounce(
      handleViewportResize,
      250,
    );
    window.addEventListener('resize', debouncedHandleResize);
    handleViewportResize(); // Initial call

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);
};

export default useViewportResize;
